import React, { useState } from "react";
import {
  Button,
  Popover,
  Box,
  Typography,
  Divider,
  ListItem,
} from "@mui/material";
import { FixedSizeList } from "react-window";

const ITEM_HEIGHT = 40;

function VirtualizedList({ items }) {
  return (
    <FixedSizeList
      height={Math.min(items.length * ITEM_HEIGHT, 300)}
      width={500}
      itemSize={ITEM_HEIGHT}
      itemCount={items.length}
      itemData={items}
    >
      {({ index, style, data }) => (
        <Box key={index} style={style}>
          <ListItem
            sx={{
              padding: "8px 12px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {data[index]}
            </Typography>
          </ListItem>
          {index < data.length - 1 && <Divider />}
        </Box>
      )}
    </FixedSizeList>
  );
}

export default function ColumnsPopover({ name, items }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button size="small" variant="outlined" onClick={handleClick}>
        View {name} ({items.length})
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: {
              p: 1,
              border: "1px solid gray",
            },
          },
        }}
      >
        <VirtualizedList items={items} />
      </Popover>
    </>
  );
}
